import Core from "@/modules/core/service/Core";

const url = {
    customer: "/api/inbox/customer/{0}"
};

export default {
    read (component, customerId, success) {
        Core.loading(component, true);
        console.log(this.url)
        Core.method.get(url.customer, customerId).then((data) => {
            Core.loading(component, false);
            success(data);
        });
    },

    update (component, customer, success) {
        Core.loading(component, true);
        Core.method.put(url.customer, customer, customer.id).then((data) => {
            Core.loading(component, false);
            success (data);
        });
    }
}